import { defineGroup, Form } from "@/form/useForm";
import Button from "components/button";
import { EAssetType } from "findef";
import { defineField, useForm } from "@/form/useForm";
import { nameField } from "../../hooks/useAssetForm/fields/name";
import { assetNameLayout } from "../../hooks/useAssetForm/layouts";
import { unlistedCompanyProfileField } from "../../hooks/useAssetForm/fields/unlistedCompanyProfile";
import { organizationNumberField } from "../../hooks/useAssetForm/fields/organizationNumber";
import type { UseAssetFormState } from "../../hooks/useAssetForm/types";
import { popModal, pushModal } from "components/modal/store";
import Icon from "components/icon";

const form = useForm<Partial<UseAssetFormState>>({
  schema: {
    asset: defineGroup({
      fields: {
        name: nameField(["asset.companyProfile"]) as unknown as any,
        companyProfile: defineField({
          type: "dbObject",
          needs: ["asset.listed", "isEditMode"],
          next: () => {
            return unlistedCompanyProfileField(false, []);
          },
        }) as unknown as any,
        organizationNumber: organizationNumberField([
          "asset.companyProfile",
          "manualTicker",
        ]) as unknown as any,
        type: defineField({
          component: "select-dropdown",
          label: "Asset Class",
          options: {
            items: [{ label: "Unlisted Equity", value: EAssetType.EQUITY }],
          },
          type: "string",
          value: EAssetType.EQUITY,
          locked: true,
        }),
        listed: defineField({
          type: "boolean",
          value: false,
        }),
      },
    }) as unknown as any,
    manualTicker: defineField({
      type: "boolean",
      value: false,
      needs: ["asset.companyProfile"],
      next: (state) => {
        const manual = !state?.asset?.companyProfile;
        return {
          value: manual,
        };
      },
    }),
  },
  layout: {
    children: (state) =>
      [
        assetNameLayout(state as unknown as any),
        { render: "asset.organizationNumber" },
        {
          component: () => {
            return () => {
              return (
                <div class="px-4 py-3 bg-gray-100 rounded-sm border border-gray-300 space-y-2">
                  <div class="grid grid-cols-[max-content_max-content] gap-1 items-center">
                    <div class="grid items-center justify-center text-gray-500">
                      <Icon
                        src={async () => import('assets/img/svg/icons/info-circle.svg?raw')}
                        fill={'currentColor'}
                        size="12.7px"
                      />
                    </div>
                    <div class="justify-start text-gray-500 text-sm font-semibold font-['Inter'] leading-tight">
                      Will be added as an unlisted equity
                    </div>
                  </div>
                  <div class="self-stretch justify-start text-gray-600 text-xs font-normal font-['Inter'] leading-none">
                    This company will be added as stock in an unlisted equity asset
                  </div>
                </div>
              );
            };
          },
        },
      ] as unknown as any,
  },
});

export const pushCreateAssetParentModal = () => {
  form.resetState();

  return new Promise<Partial<UseAssetFormState>>((resolve) => {
    const handleSubmit = () => {
      popModal();
      resolve(form.cast());
    };

    const handleClose = () => {
      console.log("errors", form.currentErrors.value);
      resolve({});
    };

    pushModal({
      title: "Create Owner Company",
      body: () =>
      <div class="border border-gray-300 p-8">
        <Form form={form} />
      </div>,
      actions: () => (
        <div class="grid grid-cols-[max-content] items-center justify-end w-full">
          <Button
            disabled={!form.touched.value || form.errors.value.length > 0}
            onClick={() => handleSubmit()}
          >
            Create
          </Button>
        </div>
      ),
      onClose: handleClose,
      style: {
        maxWidth: "600px",
        width: "auto",
        height: "fit-content",
        maxHeight: "800px",
        minHeight: "500px",
      },
    });
  });
};
